/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    CodeBlock,
    BlockType,
} from '@appblocks/codegeneration/types';

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];
    const NAME = feature.getSettingValue('NAME');

    blocks.push({
        location: 'FUNCTION_DECLARATIONS',
        blockType: BlockType.LOCATION,
        template: `
def cmd_${NAME}(data):
    #****cmd_${NAME}****#
    pass
`,
    });

    return blocks;
};
